module.exports = (function() {
    'use strict';
    const {highlightedFeePaymentMethods} = require('od-modules/utils/membership_utils');
    const storeCreditCards = require('./payment_manager/store_credit_cards');
    const inputPatternUtils = require('../modules/utils/input_pattern_utils');
    const trackingUtils = require('../modules/utils/tracking.utils');
    const trackingPageFlowUtils = require('../modules/utils/flow_tracking/tracking.page.flow.utils');
    const tagManagement = require('../modules/utils/tag_management.utils');
    const passengersUtils = require('../modules/utils/passengers.utils.js');
    const isLegacyField = (fieldName) => !Odigeo._.includes(['cvv2', 'nameoncard'], fieldName);
    const getFields = (view) => {
        return Odigeo._.values(view.model.get('cardFields'))
            .concat(view.$cachedSelectors.cardInputs.toArray());
    };

    const createField = function(name, selector, labels, options = {}) {
        return this.widget.fieldFactories[name].create({
            el: this.$el.find(selector),
            label: labels[name],
            trackEvent: Odigeo._.bind(this._trackEvent, this),
            setCardData: Odigeo._.bind(this.model.setCardData, this.model),
            options,
            model: this.model.get('cardFields')[name],
        });
    };

    const trackingPageFlowAppearances = {
        trackingPageFlowAppearancesSettings: {
            flow: 'payment_flow_appearances',
            label: 'retry:ap',
        },
    };

    const retryPageFlowTracking = (type, label) => ({
        flow: `payment_flow_${type}`,
        label: `retry:${label}`,
    });

    const retryPageFlowTrackingType = {
        ACTION: 'action',
        APPEARANCES: 'appearances',
    };

    return {
        hasShowDecimals: true,
        storeData: require('../modules/utils/storeData.utils'),
        fields: require('../modules/utils/field.utils'),
        templateSettings: {
            evaluate: /\{\{#([\s\S]+?)\}\}/g,
            interpolate: /\{\{[^#{]([\s\S]+?)[^}]\}\}/g,
            escape: /\{\{\{([\s\S]+?)\}\}\}/g,
            variable: 'tmpl',
        },
        paymentTemplateMap: {
            BANKTRANSFER: 'withoutTemplate',
            CREDITCARD: 'withoutTemplate',
            PAYPAL: 'withoutTemplate',
            SOFORT: 'withoutTemplate',
            IDEAL: 'withoutTemplate',
        },
        events: {
            'tap .template_others_container .info_hint': 'onTapOtherContainerInfoHint',
            'change .template_others_container input[type="radio"]': 'onTapOtherContainerRadio',
            'change .payment_form input[type="radio"][name="paymentType"]': 'onTapOtherContainerRadio',
            'tap .open_psd2_communication': 'onOpenPsd2Communication',
            'blur input[name="nameoncard"], input[name="ccnumber"], input[name="cvv2"]': 'trackingCreditCard',
            'change select[data-name="cardExpirationMonth"], select.cardTypeSelector, select[data-name="cardExpirationYear"]': 'trackingCreditCard',
        },
        selectors: Odigeo._.extend(storeCreditCards.selectors, {
            root: '.paymentmanager_root',
            methodSelector: '[name="paymentType"]',
            apmMethodSelector: '.payment_form:not([data-method="CREDITCARD"])',
            idealBankSelector: '.idealBank[name="idealBank"]',
            cardSaverManager: '.card_saver_manager',
            psd2InfoMsg: '.psd2_info_msg',
            ccCardTypeShowed: 'select.cardTypeSelector',
            acceptedCards: '#acceptedCards',
            acceptedCardsNew: '#acceptedCardsNew',
            acceptedBrandCards: '#acceptedBrandCards',
            ccTypeIcon: '.cc_type_icon',
            methodIcon: '.method-icon',
            paymentFailureMessage: '.od-paymentmanager-failure',
            paymentForms: '.payment_form',
            cardRow: '.payment_form[data-method="CREDITCARD"]',
            revampTemplates: '.payment_revamp_template',
            storeCardsRow: '.payment_wrapper .payment_form[data-method="CREDITCARD"]',
            cardForms: '.card_form_wrapper',
            cardInputs:
                'input[name="nameoncard"], input[name="ccnumber"], select[data-name="cardExpirationYear"], ' +
                'select[data-name="cardExpirationMonth"], select.cardTypeSelector, input[name="cvv2"]',
            cardRows: '.card_form_wrapper .paymentmanager_row',
            inputWithClearOption: '.clear_input input',
            datepickers: '.card_form .paymentmanager_datepicker',
            acceptedCardsTemplate: '.accepted-cards-template',
            acceptedBrandCardsTemplate: '.accepted-brand-cards-template',
            ccCcvHint: '.cc_ccv_hint',
            paymentmanager_tooltip: '.paymentmanager_tooltip',
            clearInput: '.clear_input',
            ccnumber: '[data-name="ccnumber"]',
            nameoncard: '[data-name=nameoncard]',
            cardExpirationMonth: '[data-name="cardExpirationMonth"]',
            cardExpirationYear: '[data-name="cardExpirationYear"]',
            cvv2: '[data-name="cvv2"]',
            ccNotDetected: '.cc_not_detected',
            saveCardData: '#saveCardData',
            cvvFieldContainer: '.cvv_field_container',
            cvvHelpContainer: '.cvv_help_container',
            cvvCloseDialog: '.close_cvv_help',
            templateOthersContainer: '.template_others_container',
            templateOthersScript: '.template_others_script',
            templateOthersRevamp: '.template_others_mobile_revamp',
            noMethodSelected: '.no_method_selected_error',
            singlePaymentMethod: '.single_payment_method',
            multiplePaymentMethod: '.multiple_payment_method',
            confirmationMessageContainer: '.pba_confirmation_container_message',
            confirmationMessageEmail: '.pba_confirmation_email',
            newCardBackArrow: '.new_card_back',
            ccNotDetectedErrorFeedback: '.cc_not_detected_error_feedback',
            defaultCreditCardFormWrapper: '.default_credit_card_form_wrapper',
            creditCardForm: '.credit_card_form',
            newCreditCardInput: '#newCreditCard',
        }),

        tmplSettings: {
            evaluate: /\{\{#([\s\S]+?)\}\}/g,
            interpolate: /\{\{([^#][\s\S]+?)\}\}/g,
        },

        inputLabelCorrespondences: {
            creditCardHolder: 'cccard_owner',
            nameoncard: 'cccard_owner',
            creditCardNumber: 'cccard_number',
            ccnumber: 'cccard_number',
            creditCardExpiration: 'cccard_expiration',
            expiration_date: 'cccard_expiration',
            creditCardCVV: 'cccard_cvv',
            cvv2: 'cccard_cvv',
            cardTypeSelector: 'cccard_notselected',
        },
        initialDatesLoad: true,

        init: function() {
            this.model.set('ccTrackingCount', 1);
            if (!this.model.get('bookingId')) {
                this.model.set('bookingId', this.$cachedSelectors.root.data('bookingId'));
            }

            this.hasShowDecimals = !!this.widget.options.hasShowDecimals;

            let templateOthers = Odigeo._.template(
                this.$cachedSelectors.templateOthersScript.html(),
                Odigeo.Utils.getTmplSettings({variable: 'tmpl'})
            );

            if (this.widget.options.isMobileRevamp) {
                templateOthers = Odigeo._.template(
                    this.$cachedSelectors.templateOthersRevamp.html(),
                    Odigeo.Utils.getTmplSettings({variable: 'tmpl'})
                );
            }

            this.paymentTemplates = {
                templateOthers,
            };

            if (this.$cachedSelectors.acceptedCardsTemplate.length) {
                this.acceptedCardsTemplate = Odigeo._.template(this.$cachedSelectors.acceptedCardsTemplate.html(), this.tmplSettings);
            }

            if (this.$cachedSelectors.acceptedBrandCardsTemplate.length) {
                this.acceptedBrandCardsTemplate = Odigeo._.template(this.$cachedSelectors.acceptedBrandCardsTemplate.html(), this.tmplSettings);
            }

            storeCreditCards.view.initView.call(this);

            Odigeo.UIElements.collapsive.enhance(this.$cachedSelectors.creditCardForm, {initiallyExpanded: true});

            this.paymentMethodSelectors();

            this.$cachedSelectors.paymentForms
                .on(
                    Odigeo.Events.blur,
                    'input[name]:not([name="paymentType"]), select[name], select[data-name]',
                    Odigeo._.bind(this.cardChangeHandler, this)
                )
                .on(Odigeo.Events.change, 'select[name], select[data-name], select[name]:not([name="idealBank"])',
                    Odigeo._.bind(this.cardChangeHandler, this))
                .on(
                    Odigeo.Events.focus,
                    'input[name], select[name], select[data-name]',
                    Odigeo._.bind(function(e) {
                        var $input = $(e.target);
                        var $paymentRow = $input.closest('.paymentmanager_row');

                        $input.closest('.validation_field').attr('data-state', 'init');
                        if (Odigeo._.indexOf(['text', 'tel'], $input.attr('type')) > -1) {
                            this.fields.showHidePlaceholder($input, true);
                        }
                        $paymentRow.addClass('focused');
                        if (Odigeo.AB.isCobaltDesktopForms) {
                            var $prismaGroup = $input.closest('.prisma-input-group');
                            $prismaGroup.addClass('focused');
                        }
                    }, this)
                );
            this.$cachedSelectors.idealBankSelector.on(Odigeo.Events.change, Odigeo._.bind(this.onChangeIdealBank, this));
            if (this.$cachedSelectors.idealBankSelector.length) {
                this.$cachedSelectors.idealBankSelector.val('');
            }

            this.$cachedSelectors.methodSelector.toggleClass('is-iOS', Odigeo.Device.navigator.isIOS);

            this.$cachedSelectors.datepickers
                .on('focus', function(e) {
                    var $el = $(e.target);
                    $el.parent().removeClass('placeholder');
                })
                .on(
                    'change',
                    Odigeo._.bind(function(e) {
                        var $el = $(e.target);
                        $el.parent().toggleClass('placeholder', Odigeo._.isEmpty($el.val()));
                        Odigeo.trigger(this.widget.id + ':expirationDateChange', $el);
                        Odigeo.trigger(this.widget.id + ':checkExpiringCard', $el);
                    }, this)
                );

            Odigeo._.each(
                this.$cachedSelectors.cardForms,
                function(form) {
                    var type = $(form)
                        .data('card')
                        .split('|');

                    Odigeo._.each(
                        $('[name]', form),
                        function(input) {
                            var pattern = $(input).data('pattern');
                            if (pattern) {
                                this.model.setRegExp(type, input.name, pattern);
                            }
                        },
                        this
                    );
                },
                this
            );

            this.$cachedSelectors.ccTypeIcon.attr('data-card', '');

            this.$cachedSelectors.inputWithClearOption.on(Odigeo.Events.blur, Odigeo._.bind(this.onToggleFocused, this, false));

            this.$cachedSelectors.clearInput.on(Odigeo.Events.tap, Odigeo._.partial(this.fields.clearField, _));

            if (!Odigeo._.isEmpty(this.$cachedSelectors.ccCcvHint) && Odigeo.UIElements.hint) {
                Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), this.$cachedSelectors.ccCcvHint, {
                    events: {
                        tap: true,
                    },
                });
            }

            this._setInputsPattern();

            if (Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'))) {
                this.showConfirmationEmailMessage();
            }
        },

        createFields(labels) {
            const fields = {
                nameoncard: createField.call(this, 'nameoncard', '.name_on_card_field', labels),
                cvv2: createField.call(this, 'cvv2', '.cvv2_field', labels, {
                    bigCvv: this.widget.options.bigCvv,
                    $cvvSlideContainer: this.widget.options.cvvInline ? this.$el.find('.cvv_slide_container') : null,
                }),
            };
            if (this.widget.options.cvvInline) {
                Object.assign(fields, {
                    ccExpirationDate: createField.call(this, 'ccExpirationDate', '#cc-expiration-date-input', labels),
                });
            }
            return fields;
        },

        _setInputsPattern: function() {
            inputPatternUtils.initInputPattern(this.$cachedSelectors.ccnumber);
        },

        toggleSaveDataCheck: function(isDisplayed) {
            this.$cachedSelectors.cardSaverManager.toggleClass('odf-hidden', isDisplayed);
        },
        paymentMethodSelectors: function() {
            this.$cachedSelectors.methodSelector.on(
                'change',
                Odigeo._.bind(function(e) {
                    var $el = $(e.target);

                    var selectedStorageCreditCard = this.model.get('selectedStorageCreditCard');
                    var $storedCCinputsContainer = this.widget.view.$cachedSelectors.storageCreditCardContainer;

                    if (selectedStorageCreditCard && $storedCCinputsContainer.find('input[data-id=' + selectedStorageCreditCard.id + ']').length) {
                        this.widget.view.$cachedSelectors.storageCreditCardContainer
                            .find('input[data-id=' + selectedStorageCreditCard.id + ']')
                            .prop('checked', true);
                    } else if (!$el.is('input[type="radio"]') || $el.is(':checked')) {
                        if (Odigeo.AB.isMobileRevamp) {
                            if (this.model.get('storedCCList').length > 0) {
                                this.$cachedSelectors.storedCreditCard.prop('checked', false);
                                this.hideCreditCard();
                            }
                        } else {
                            this.$cachedSelectors.storedCreditCard.prop('checked', false);
                            this.widget.model.set('selectedStorageCreditCard', null);
                        }
                        this.model.changePaymentMethod(e.target.value);
                    }
                }, this)
            );
        },
        onChangeIdealBank: function(e) {
            const $el = $(e.target);
            const $validationField = $el.closest('.validation_field');
            const val = $el.val();

            $validationField.removeClass('focused');
            this.model.setIdealBank(val);
            if (this.model.isIdealRequestValid()) {
                $validationField.attr('data-state', 'valid');
            } else {
                $validationField.attr('data-state', 'empty');
            }
        },
        onToggleFocused: function(isFocused, event) {
            const $element = $(event.target);
            const name = $element.attr('name');
            if (isLegacyField(name)) {
                const $paymentRow = $element.closest('.paymentmanager_row');
                $paymentRow.toggleClass('focused', isFocused);
            }
        },

        cardDataChanged: function(name, $el, method) {
            var data = {};
            data[name] = Odigeo.Utils.trim($el.val());
            Odigeo.Utils.apply($el);
            this.trigger('change:cardData', method, data);
        },

        creditCardExpirationChanged: function($el, name, method, status) {
            var ccExpiration = this.widget.enhancedElementsList.ccExpiration;
            var ccExpirationData = ccExpiration.checkInputValues();
            if (status === 'valid' || (ccExpirationData.year !== '-1' && ccExpirationData.month !== '-1')) {
                this.cardDataChanged(name, $el, method);
            }
        },

        handleLegacyField: Odigeo._.debounce(function(name, $el, method, $validationField) {
            this.trackError(
                Odigeo._.indexOf(['cardExpirationMonth', 'cardExpirationYear'], name) > -1 ? 'expiration_date' : name,
                $validationField.attr('data-state'),
                'inline'
            );
        }, 25),

        cardChangeHandler: function(e) {
            const $el = $(e.target);
            const name = $el.attr('data-name');
            const method = $el.closest('.card_form_wrapper').data('card');
            const $validationField = $el.closest('.validation_field');
            const val = Odigeo.Utils.trim($el.val());

            $validationField.removeClass('focused');

            if (name === 'cardType') {
                if (val) {
                    $validationField.attr('data-state', 'valid');
                }
                this.trigger('change:cardType', val);
            } else if (name === 'creditCardExpiration' && !Odigeo._.isUndefined(this.widget.enhancedElementsList.ccExpiration)) {
                this.creditCardExpirationChanged($el, name, method, $validationField.attr('data-state'));
            } else if (isLegacyField(name) && (!this.widget.options.isMobileRevamp || this.model.get('chosenMethod'))) {
                this.cardDataChanged(name, $el, method);
                this.handleLegacyField(name, $el, method, $validationField);
                this.fields.showHidePlaceholder($el, false);
            }

            if (Odigeo.AB.isCssVariationMobile && e.type === 'change' && (name === 'cardExpirationMonth' || name === 'cardExpirationYear')) {
                Odigeo.trigger(this.widget.id + ':checkExpiringCard', $el);
            }
        },

        onOpenPsd2Communication: function() {
            trackingUtils.trackEvent('payment_details', 'psd2_message_moreinfo_click');
            Odigeo.trigger(this.widget.id + ':openPsd2Communication');
        },

        trackingCreditCard: function(e) {
            const el = e.target;

            if ($(el).is(':valid') && $(el).closest('.prisma-input-group').not('[data-state="invalid"]').length
                && $(el).val() !== $(el).data('old-value')) {
                if ($(el).hasClass('cardTypeSelector')
                    && this.$cachedSelectors.ccnumber.closest('.prisma-input-group').not('[data-state="invalid"]').length) {
                    this.$cachedSelectors.ccnumber.data('old-value', this.$cachedSelectors.ccnumber.val());
                }

                if (this.$cachedSelectors.cardForms.find('[data-state]').length ===
                this.$cachedSelectors.cardForms.find('[data-state="valid"]').length &&
                !this.$cachedSelectors.cardForms.find('[data-state="invalid"]').length) {
                    trackingUtils.trackEventWithCategory(
                        'flights_pay_page',
                        'payment_details',
                        'fill-payment-form_' + this.model.get('ccTrackingCount') + '_pag:pay'
                    );
                    this.model.set('ccTrackingCount', this.model.get('ccTrackingCount') + 1 );
                }

                $(el).data('old-value', $(el).val());
            }
        },

        enhancedElementsList: function(obj) {
            this.widget.enhancedElementsList[obj.uielement] = obj.element;
        },

        trackFormErrorEvents: function(errors) {
            Odigeo._.each(
                errors,
                function(errorType, inputName) {
                    if (isLegacyField(inputName)) {
                        this.trackError(inputName, errorType, 'submit');
                    }
                },
                this
            );
        },

        trackError: function(name, status, type) {
            if (
                (status === 'invalid' || status === 'empty') &&
                this.widget.id !== 'post-booking-payment' && this.widget.id !== 'seatmap-payment-checkin'
            ) {
                this._trackEvent(
                    'payment_details_error',
                    this.inputLabelCorrespondences[name] +
                        (type === 'inline' ? '_inline' : '_submit') +
                        (status === 'empty' ? '_missing_error' : '_invalid_error')
                );
            }
        },

        getTemplate(templateName, options) {
            return this.paymentTemplates[templateName](options);
        },

        updatePaymentOptions: function(model) {
            var methods = model.get('paymentMethods');
            var selectedMethod = model.get('chosenMethod');
            var method;
            var tmplName;

            if (methods && methods.length === 1) {
                this.$cachedSelectors.singlePaymentMethod.removeClass('odf-hidden');
            } else {
                this.$cachedSelectors.multiplePaymentMethod.removeClass('odf-hidden');
            }

            this.$cachedSelectors.templateOthersContainer.empty();
            Odigeo._.each(
                methods,
                function(methodDto) {
                    method = methodDto.method ? methodDto.method.toUpperCase() : '';
                    tmplName = this.paymentTemplateMap[method];

                    if (!tmplName || tmplName === 'others') {
                        const options = {
                            methodUpperCase: method,
                            methodLowerCase: method.toLowerCase(),
                            description: methodDto.description ? methodDto.description : {},
                        };

                        this.$cachedSelectors.templateOthersContainer.append(this.getTemplate('templateOthers', options));
                        this.updateDomSelectorsToCache();
                    }
                },
                this
            );

            var $forms = this.$cachedSelectors.root.find('.payment_form');

            Odigeo._.each(
                $forms,
                Odigeo._.flowRight(function($form) {
                    var formMethod = $form.data('method');
                    var method = Odigeo._.find(methods, {method: formMethod});
                    var isObject = Odigeo._.isObject(method);

                    if (!Odigeo._.isUndefined(method) && method.method === 'PAYPAL') {
                        trackingUtils.trackEventWithCategory('flights_pay_page', 'payment_details', 'payment_method_onload_pp');
                    }

                    if (!Odigeo._.isUndefined(method) && method.method === 'CREDITCARD') {
                        trackingUtils.trackEventWithCategory('flights_pay_page', 'payment_details', 'payment_method_onload_cc');
                    }

                    $form.toggleClass('enabled', isObject);

                    if (isObject) {
                        const paymentMethodFee = $form.find('.paymentmanager_method_fee');

                        if (Odigeo.Membership.isHighlightMessagePaypalSofortFee && highlightedFeePaymentMethods.includes(method.method)) {
                            paymentMethodFee.html(Odigeo.Utils.formatCurrency(method.fee));
                        } else {
                            paymentMethodFee.html((method.fee > 0 ? '+' : '') + Odigeo.Utils.formatCurrency(method.fee));
                        }
                    }
                }, $)
            );

            if (Odigeo.AB.isCobaltDesktopForms && methods && methods.length === 1) {
                $('.credit-card-check').addClass('odf-hidden');
            }

            if (!this.widget.options.isMobileRevamp) {
                $forms
                    .filter('[data-method="' + selectedMethod + '"]')
                    .find('input[name="paymentType"]')
                    .prop('checked', true)
                    .trigger('change', true);
            }

            var cards = Odigeo._.find(methods, {
                method: 'CREDITCARD',
            });

            if (!Odigeo._.isUndefined(cards)) {
                var $selectors = this.$cachedSelectors;
                var selectedCard = model.get('chosenCard');

                this.model.defaultCreditCard = selectedCard ? selectedCard : cards.info.cardTypes[0];
                Odigeo.trigger(this.widget.id + ':paymentOptionsUpdated', {
                    cards: cards.info.cardTypes,
                    defaultCc: this.model.defaultCreditCard,
                    chosenMethod: selectedMethod,
                });
                this.model.set('chosenCard', this.model.defaultCreditCard);

                if ($selectors.acceptedCards.length && $selectors.acceptedCardsTemplate.length) {
                    var uniqCards = Odigeo._.chain(cards.info.cardTypes).uniq(Odigeo._.property('code'));
                    var $accepted = this.removeDuplicateCards(uniqCards);
                    $selectors.acceptedCards.html($accepted);
                    $selectors.acceptedCardsNew.html($accepted);
                }

                if ($selectors.acceptedBrandCards.length && $selectors.acceptedBrandCardsTemplate.length) {
                    var brands = [
                        {brand: 'VISA', cards: ['VE', 'VD', 'VI', 'HS', 'VV', 'VB']},
                        {brand: 'AMEX', cards: ['AX', 'DL']},
                        {brand: 'MASTERCARD', cards: ['CA', 'MP', 'MD', 'E1', 'MA', 'EY', 'EA', 'MI']},
                        {brand: 'JCB', cards: ['JC']},
                        {brand: 'DINERS', cards: ['DC']},
                        {brand: 'DISCOVER', cards: ['DS']},
                        {brand: 'SOLO', cards: ['PP']},
                        {brand: 'CB', cards: ['CB']},
                    ];
                    var getBrands = function(card) {
                        return Odigeo._.find(brands, function(elem) {
                            return Odigeo._.contains(elem.cards, card.code);
                        });
                    };
                    var cardsGroup = Odigeo._.chain(cards.info.cardTypes).uniq(Odigeo._.property('code'));
                    var brandCodes = cardsGroup.map(getBrands).value();
                    var $brandsAccepted = Odigeo._.uniq(brandCodes).map(this.acceptedBrandCardsTemplate);
                    $selectors.acceptedBrandCards.html($brandsAccepted);
                }
            }
            Odigeo.trigger(this.widget.id + ':ready');
            Odigeo.trigger(this.widget.id + ':paymentMethodsUpdated', model.get('paymentMethods'));

            if (Odigeo.AB.isCobaltDesktopForms && this.initialDatesLoad) {
                $('.prisma-select[data-name="cardExpirationMonth"]').parents('.prisma-input-group').attr('data-state', 'valid');
                $('.prisma-select[data-name="cardExpirationYear"]').parents('.prisma-input-group').attr('data-state', 'valid');
                this.initialDatesLoad= false;
            }
        },

        removeDuplicateCards: function(uniqCards) {
            const masterCardConsumerCode = 'MF';
            const masterCardRegular = 'MD';
            const masterCardPrepaid = 'MP';
            const masterCardStandard = 'CM';
            const masterCardPrepaidItalia = 'MI';
            const masterCard = 'CA';
            const prepayEdreamsCard = 'EY';
            const agosEdreamsCard = 'EA';
            const masterCardEdreams = 'EC';
            const creditAmericanExpress = 'AB';
            const americanExpress = 'AX';
            const visaRegular = 'VI';
            const visaDebit = 'VD';
            const visaElectron = 'VE';

            const removeDuplicateMasterCardCC = function(card) {
                return !(
                    (card.code === masterCardConsumerCode || card.code === masterCardStandard) &&
                    (Odigeo._.includes(creditCardCodes, masterCardConsumerCode) || Odigeo._.includes(creditCardCodes, masterCardStandard)) &&
                    Odigeo._.includes(creditCardCodes, masterCard)
                );
            };
            const removeDuplicateVisa = function(card) {
                return !(
                    (card.code === visaElectron || card.code === visaDebit) &&
                    (Odigeo._.includes(creditCardCodes, visaElectron) || Odigeo._.includes(creditCardCodes, visaDebit)) &&
                    Odigeo._.includes(creditCardCodes, visaRegular)
                );
            };

            const removeDuplicateMasterCard = function(card) {
                return !(
                    (card.code === masterCardPrepaid || card.code === masterCardRegular || card.code === masterCardPrepaidItalia) &&
                    (Odigeo._.includes(creditCardCodes, masterCardPrepaid) ||
                        Odigeo._.includes(creditCardCodes, masterCardRegular) ||
                        Odigeo._.includes(creditCardCodes, masterCardPrepaidItalia)) &&
                    Odigeo._.includes(creditCardCodes, masterCard)
                );
            };

            const removeDuplicateEdreamsCard = function(card) {
                return !(
                    card.code === prepayEdreamsCard &&
                    Odigeo._.includes(creditCardCodes, prepayEdreamsCard) &&
                    Odigeo._.includes(creditCardCodes, agosEdreamsCard)
                );
            };
            const removeMasterCardEdreams = function(card) {
                return card.code !== masterCardEdreams;
            };
            const removeDuplicateAmericanExpress = function(card) {
                return !(
                    card.code === creditAmericanExpress &&
                    Odigeo._.includes(creditCardCodes, creditAmericanExpress) &&
                    Odigeo._.includes(creditCardCodes, americanExpress)
                );
            };
            const getCreditCardCode = function(card) {
                return card.code;
            };
            const creditCardCodes = uniqCards.map(getCreditCardCode).value();
            return uniqCards
                .filter(removeDuplicateMasterCardCC)
                .filter(removeDuplicateEdreamsCard)
                .filter(removeMasterCardEdreams)
                .filter(removeDuplicateAmericanExpress)
                .filter(removeDuplicateMasterCard)
                .filter(removeDuplicateVisa)
                .map(this.acceptedCardsTemplate)
                .value();
        },

        hideCreditCard: function() {
            this.$cachedSelectors.storedCardLabel.removeClass('selected');
            this.changeSelectedNewStoredCard();
            this.moveCvv(this.$el.find('.mobile_form_cvv_container'));
            this.$cachedSelectors.creditCardForm.trigger('togglePanelByParameter', false);
            this.showHideSaveDataCardAgree(false);
            this.widget.model.set('selectedStorageCreditCard', null);
            this.$cachedSelectors.mobileFormCvvContainer.addClass('odf-hidden');
        },

        updatePaymentMethod: function(model) {
            var chosenMethod = model.get('chosenMethod');
            var $forms = this.$cachedSelectors.root.find('.payment_form');

            const hasStoredCardsDisplayed = this.model.get('storedCCList').length > 0;

            this.$cachedSelectors.methodIcon.toggle(chosenMethod === 'PAYPAL');
            this.$cachedSelectors.methodSelector.toggleClass('paymentType', chosenMethod === 'PAYPAL');
            this.$cachedSelectors.noMethodSelected.addClass('hide');

            if (Odigeo.AB.isCssVariationMobile) {
                if (!hasStoredCardsDisplayed) {
                    this.$cachedSelectors.newCreditCardInput.prop('checked', chosenMethod === 'CREDITCARD');
                }
                if (chosenMethod !== 'CREDITCARD') {
                    $forms
                        .not('[data-method="' + chosenMethod + '"]')
                        .find('input[name="storedCreditCard"]')
                        .prop('checked', false);
                }
                this.$cachedSelectors.creditCardForm.trigger('togglePanelByParameter', chosenMethod === 'CREDITCARD' && !hasStoredCardsDisplayed);
                $forms
                    .not('[data-method="' + chosenMethod + '"]')
                    .find('input[name="paymentType"]')
                    .prop('checked', false);
            }

            if (Odigeo.AB.isMobileRevamp && hasStoredCardsDisplayed) {
                if (chosenMethod !== 'CREDITCARD') {
                    $forms.removeClass('active');
                    this.$cachedSelectors.storedCardsActive.addClass('active');
                }
                $forms.filter('[data-method="' + chosenMethod + '"]').addClass('active');
            } else {
                chosenMethod = chosenMethod || Odigeo.Session.get('chosenMethod');
                $forms
                    .removeClass('active')
                    .filter('[data-method="' + chosenMethod + '"]')
                    .addClass('active');

                if (Odigeo.AB.isCssVariationMobile) {
                    $forms
                        .filter('[data-method="' + chosenMethod + '"]')
                        .find('input[name="paymentType"]')
                        .prop('checked', true);
                }
            }

            if (!Odigeo.AB.isCssVariationMobile) {
                $forms
                    .filter('[data-method="' + chosenMethod + '"]')
                    .find('input[name="paymentType"]')
                    .prop('checked', true);
            }

            if (Odigeo.AB.isCssVariationMobile) {
                const isNewCreditCardInputSelected = this.$cachedSelectors.defaultCreditCardFormWrapper.find('#newCreditCard').is(':checked');

                this.$cachedSelectors.defaultCreditCardFormWrapper.toggleClass('active', isNewCreditCardInputSelected);
            }

            this.$cachedSelectors.root.attr('data-state', model.isValid() ? 'valid' : 'invalid');

            if (!this.widget.options.isMobileRevamp) {
                this.$cachedSelectors.root.toggleClass(
                    'od-stored-cards-visible',
                    chosenMethod === 'CREDITCARD' && Odigeo._.isObject(this.model.get('user'))
                );
            }
            Odigeo.trigger(this.widget.id + ':paymentMethodChanged', chosenMethod);
            trackingUtils.trackEventWithCategory(
                this.widget.options.isDynpack ? 'dynpack_pay_page' : 'flights_pay_page',
                'payment_details',
                'payment_widget_click_' + this.model.getCommitTrackingSuffixLabel(chosenMethod)
            );
        },

        updateCreditCard: function(model) {
            var chosenCard = model.get('chosenCard');
            var chosenMethod = model.get('chosenMethod');
            var chosenCardMethod;

            chosenCardMethod = !Odigeo._.isUndefined(chosenCard) ? chosenCard.method : '';

            if (!this.widget.options.isMobileRevamp) {
                var paymentForms = this.$cachedSelectors.paymentForms;
                for (var i = 0, paymentFormLen = paymentForms.length; i < paymentFormLen; i++) {
                    var paymentMethod = $(paymentForms[i]);
                    paymentMethod.toggleClass('active', paymentMethod.data('method') === chosenMethod);
                }
            }

            if (chosenCardMethod) {
                var cardForms = this.$cachedSelectors.cardForms;
                for (var j = 0, cardFormLen = cardForms.length; j < cardFormLen; j++) {
                    var card = $(cardForms[j]);
                    var methods = card.data('card').split('|');
                    card.toggleClass('active', methods.indexOf(chosenCardMethod) >= 0);
                }
            }

            if (chosenCardMethod === 'CREDITCARD') {
                const fieldsToValidate = ['ccnumber', 'cvv2', 'nameoncard', 'cardExpirationMonth', 'cardExpirationYear', 'cardTypeSelector'];
                const creditCardData = model.get('creditCardData');
                const cardFieldModels = model.get('cardFields');
                const notEmptyFields = [];
                Odigeo._.each(fieldsToValidate, function(field) {
                    if (creditCardData[field] || Odigeo._.method([field, 'get'], 'value')(cardFieldModels)) {
                        notEmptyFields.push(field);
                    }
                });

                this.model.isValid();

                this.showErrors({changes: notEmptyFields, errors: this.model.validationError, fullValidation: false});
            }
        },

        showNegativeFee: function() {
            this.$cachedSelectors.paymentFailureMessage.toggleClass('is-iOS', Odigeo.Device.navigator.isIOS).removeClass('hidden');
        },

        showErrors: function(params) {
            let cardFieldModels = this.model.get('cardFields');
            var changes = params.changes || [];
            var errors = params.errors || {};
            var options = params.opts || this.widget.options.errorHandling || {};
            var showErrorsResume = params.showErrorsResume || false;
            const avoidTrackErrors = params.avoidTrackErrors || false;
            var $changed;
            var changedIndex;
            var $inputs;
            var errorList = {};
            var fullValidation = params.fullValidation || false;

            $changed = this.$cachedSelectors.cardInputs.filter(function(idx, el) {
                return Odigeo._.includes(changes, $(el).attr('data-name'));
            });
            changedIndex = this.$cachedSelectors.cardInputs.index($changed.last());

            if (options.all) {
                $inputs = this.$cachedSelectors.cardInputs;
            } else if (options.previous) {
                $inputs = Odigeo._.take(this.$cachedSelectors.cardInputs, changedIndex + 1);
            } else {
                $inputs = $changed;
            }

            $changed.last().removeAttr('data-init');

            if (
                Odigeo._.has(errors, 'creditCardExpiration') &&
                !showErrorsResume &&
                (this.$cachedSelectors.cardExpirationYear.attr('data-init') ||
                    this.$cachedSelectors.cardExpirationMonth.attr('data-init') ||
                    (!fullValidation && this.isExpirationCreditCardNotInitialized())) &&
                (!options.previous || changedIndex <= this.$cachedSelectors.cardInputs.index(this.$cachedSelectors.cardExpirationYear))
            ) {
                errors = Odigeo._.omit(errors, 'creditCardExpiration');
                $changed = $changed.not(this.$cachedSelectors.cardExpirationYear).not(this.$cachedSelectors.cardExpirationMonth);
            }

            if (!this.$cachedSelectors.ccNotDetected.hasClass('odf-hidden') && this.$cachedSelectors.ccCardTypeShowed.val() === '') {
                errorList.cardTypeSelector = 'empty';
                errors.cardTypeSelector = 'empty';
            }

            Odigeo._.each(
                $inputs,
                function(el) {
                    var $el = $(el);
                    var name = this.getEquivalenceErrorName($el);
                    var $validationField = $el.closest('.validation_field');
                    if (Odigeo._.has(errors, name)) {
                        $validationField.attr('data-state', errors[name]);
                        this.fields.showError($validationField, false);
                        errorList[name] = errors[name];
                    } else {
                        if ($validationField.attr('data-state') !== 'valid') {
                            $validationField.attr('data-state', '');
                        }
                    }
                },
                this
            );
            Odigeo._.each(cardFieldModels, (fieldModel, name) => {
                errorList[name] = fieldModel.validate(fieldModel.toJSON());
            });

            // CCNumber not detect card

            this.$cachedSelectors.ccNotDetectedErrorFeedback.toggleClass('odf-hidden', !Odigeo._.has(errors, 'ccnumber'));

            if (Odigeo._.has(errors, 'ccnumber')) {
                Odigeo.trigger(`${this.widget.id}:hideBlockingBinsSuccessMessage`);
            }

            if (Odigeo._.has(errors, 'cvv2') && fullValidation) {
                this.validateStoredCreditCardCvv();
            }

            if (showErrorsResume && errors.chosenMethod && this.widget.options.isMobileRevamp) {
                this.$cachedSelectors.noMethodSelected.removeClass('hide');
                Odigeo.Utils.scrollToElement(this.$cachedSelectors.noMethodSelected);
            }

            if (!this.$cachedSelectors.cardExpirationYear.attr('data-init') || !this.$cachedSelectors.cardExpirationMonth.attr('data-init')) {
                var $fieldMonth = this.$el.find('.field_month');
                var $fieldYear = this.$el.find('.field_year');
                var expiration = errors.creditCardExpiration ? errors.creditCardExpiration : 'valid';
                $fieldMonth.attr('data-state', expiration);
                $fieldYear.attr('data-state', expiration);
                this.fields.showError($fieldMonth, false);
            }

            if ($changed.length) {
                Odigeo._.each(
                    $changed,
                    function(el) {
                        var $el = $(el);
                        var name = this.getEquivalenceErrorName($el);
                        var valid = !Odigeo._.has(errors, name);
                        var $wrapper = $el.closest('.validation_field');
                        $wrapper.attr('data-state', valid ? 'valid' : errors[name]);
                    },
                    this
                );
            }

            const isIdealValid = this.model.isIdealRequestValid();
            if (!isIdealValid && fullValidation) {
                let $validationField = this.$cachedSelectors.idealBankSelector.closest('.validation_field');
                $validationField.attr('data-state', 'empty');
            }
            const isValidForm = Odigeo._.isEmpty(errors) && isIdealValid;

            this.$cachedSelectors.root.attr('data-state', isValidForm ? 'valid' : 'invalid');
            this.$cachedSelectors.paymentmanager_tooltip.toggleClass('hidden', isValidForm);

            if (showErrorsResume && Odigeo._.keys(errorList).length > 0) {
                if (!avoidTrackErrors) {
                    this.trackFormErrorEvents(errorList);
                }
                Odigeo.trigger(this.widget.id + ':showErrorsResume', errorList);
            }
        },

        getEquivalenceErrorName: function($el) {
            var inputErrorEquivalencies = {
                cardExpirationYear: 'creditCardExpiration',
                cardExpirationMonth: 'creditCardExpiration',
            };
            var dataName = $el.attr('data-name');
            return inputErrorEquivalencies[dataName] || dataName;
        },

        isExpirationCreditCardNotInitialized: function() {
            return !this.$cachedSelectors.cardExpirationYear.val() || !this.$cachedSelectors.cardExpirationMonth.val();
        },

        showDialog: function(title, text, buttons) {
            var popup = Odigeo.UIElements.createDialog('<b>' + title + '</b>', '<div class="od-ui-dialog-confirmation">' + text + '</div>', buttons);
            Odigeo.UIElements.showDialog(popup);
            return popup;
        },

        showErrorPaymentRetryDialog: function(params) {
            this.widget.isPaymentMethodRetry = true;
            var options = this.widget.options;
            var popup;
            var buttons;
            var retryDescription = options.error_retry_description;
            var hasFlowErrors = !Odigeo._.isUndefined(params) && !Odigeo._.isUndefined(params.flowErrors) && !Odigeo._.isEmpty(params.flowErrors);
            var message;
            var error;
            var errorsObj = {
                UNAVAILABLE_ONLINE_COLLECTION_METHOD: {
                    fn: function(context) {
                        if (options.hasNegativeOrZeroPayment) {
                            retryDescription = options.error_retry_negative_payment_collection;
                        }
                        return context.showDialog(options.error_retry_title, retryDescription, buttons);
                    },
                },
                FORBIDDEN_ATTEMPT_NEGATIVE_COLLECTION: {
                    fn: function(context) {
                        Odigeo._.templateSettings = {
                            evaluate: /\{\{#(.+?)\}\}/g,
                            interpolate: /\{\{([^#].*?)\}\}/g,
                        };

                        var forbiddenAttemptNegCollection = Odigeo._.template(context.$widget.find('.forbidden_attempt_negative_collection').html());
                        var nextDate = Odigeo.Utils.createDateFromString(message.messages.NEXT_AVAILABLE_DATE);
                        var templateValues = {
                            type: 'description',
                            next_available_date: Odigeo.Utils.formatDate(
                                message.messages.NEXT_AVAILABLE_DATE,
                                context.widget.options.velocityMessagesDateFormat
                            ),
                            credit_card_type_name: message.messages.CREDIT_CARD_TYPE_NAME,
                            days_to_date: Odigeo.Utils.getRemainingDays(nextDate.getTime()),
                            credit_card_number: message.messages.CREDIT_CARD_NUMBER,
                        };

                        return context.showDialog(options.error_retry_title, forbiddenAttemptNegCollection(templateValues), buttons);
                    },
                },
                CART_TYPE_NOT_MATCH: {
                    fn: function(context) {
                        var paymentRetryInfo = params.myTrip.paymentRetryInfo;
                        if (!Odigeo._.isNull(paymentRetryInfo.newCreditCard) && !Odigeo._.isNull(paymentRetryInfo.paymentDetails.creditCardDetails)) {
                            Odigeo.Router.navigate('payment', {isSecured: true, replace: true});
                            context.widget.execute('fillForm', paymentRetryInfo.paymentDetails.creditCardDetails);
                            context.showPaymentRetryPopUp('sm', paymentRetryInfo);
                        }
                    },
                },
                COLLECTION_WRONG_CVV2: {text: 'error_retry_wrongcvv_description'},
                COLLECTION_CARD_EXPIRED: {text: 'error_retry_cardexp_description'},
                COLLECTION_INVALID_CARD_NUMBER: {text: 'error_retry_invcardnum_description'},
                COLLECTION_DECLINED: {text: 'error_retry_colldeclined_description'},
                COLLECTION_BUYERS_FUNDING_SOURCE_FAILED: {text: 'buyersFundingSourceFailed'},
                FRAUD_NON_CHARGEABLE_ATTEMPT: {text: 'error_retry_fraudnoncharg_description'},
                ITINERARY_PROVIDER_2: {text: 'error_retry_itineraryprov_description'},
                COLLECTION_FRAUD_SUSPECT: {text: 'error_retry_fraudsuspect_description'},
                COLLECTION_UNSUPPORTED_GATEWAY_COLLECTION_METHOD: {text: 'error_retry_forbgate_description'},
                COLLECTION_INSUFFICIENT_CREDIT: {text: 'error_retry_insuficientcredit_description'},
                COLLECTION_WRONG_CREDITCARD_EXPIRATION_DATE: {text: 'error_retry_wrongexpirationdate_description'},
                COLLECTION_WRONG_ELV_ACCOUNT: {text: 'error_retry_wrongelv_description'},
                COLLECTION_ORDER_NOT_AUTHORIZE: {text: 'error_retry_ordernotauthorize_description'},
                COLLECTION_CARD_NOT_IN_AUTHORIZERS_DB: {text: 'error_retry_cardnotinauthorizersdb_description'},
                COLLECTION_ACQUIRER_UNAVAILABLE: {text: 'error_retry_acquirerunavailable_description'},
                COLLECTION_DATA_VALIDATION_ERROR: {text: 'error_retry_datavalidation_description'},
                COLLECTION_INVALID_AMOUNT: {text: 'error_retry_invalidamount_description'},
                COLLECTION_INVALID_CURRENCY: {text: 'error_retry_invalidcurrency_description'},
                COLLECTION_AMOUNT_HIGHER_THAN_ALLOWED: {text: 'error_retry_amounthigher_description'},
                BOOKING_PAYMENT_RETRY: {text: 'error_retry_paymentretry_description'},
                COLLECTION_UNKNOWN: {text: 'error_retry_collectionunknown_description'},
                COLLECTION_UNKNOWN_ORDER: {text: 'error_retry_unknownorder_description'},
                COLLECTION_UNKNOWN_ORIGIN_IP: {text: 'error_retry_unknownorigin_description'},
                COLLECTION_ORDER_ALREADY_USED: {text: 'error_retry_orderalreadyused_description'},
                COLLECTION_TRANSACTION_NO_EXIST: {text: 'error_retry_transactionnoexists_description'},
                BOOKING_STOP: {text: 'error_retry_bookingstop_description'},
            };

            buttons = [
                {
                    text: options.error_retry_retry,
                    style: 'od-ui-dialog-button-default',
                    handler: Odigeo._.bind(function() {
                        Odigeo.UIElements.hideDialog(popup);
                        Odigeo.requireWidget('payment-manager', 'paymentmanager', function(paymentManager) {
                            paymentManager.execute('paymentRetry');
                        });
                        Odigeo.Router.navigate('payment', {isSecured: true, replace: true});
                        this._trackVirtualPage('payment', true);
                        trackingPageFlowUtils.launchEvent(retryPageFlowTracking(retryPageFlowTrackingType.ACTION, 'OK'));
                    }, this),
                },
            ];

            if (hasFlowErrors) {
                message = Odigeo._.first(Odigeo._.values(params.flowErrors)) || {};
                if (message.errorMessageKey) {
                    trackingUtils.trackEventWithCategory('flights_pay_page', 'payment_details_error', message.errorMessageKey);
                }
                error = errorsObj[message.errorMessageKey] || {};
                if (error.fn) {
                    popup = error.fn(this);
                } else if (error.text) {
                    popup = this.showDialog(options.error_retry_title, options[error.text], buttons);
                    trackingPageFlowUtils.launchAppearancesTracking(trackingPageFlowAppearances);
                } else {
                    popup = this.showDialog(options.error_retry_title, retryDescription, buttons);
                }
            }
        },

        showErrorPaymentRetryInline: function(params) {
            this.widget.isPaymentMethodRetry = true;
            var hasFlowErrors = !Odigeo._.isUndefined(params) && !Odigeo._.isUndefined(params.flowErrors) && !Odigeo._.isEmpty(params.flowErrors);
            var message;
            var error;
            var errorsObj = {
                UNAVAILABLE_ONLINE_COLLECTION_METHOD: {type: 'unavaicoll'},
                FORBIDDEN_ATTEMPT_NEGATIVE_COLLECTION: {type: 'negative'},
                CART_TYPE_NOT_MATCH: {type: ''},
                COLLECTION_WRONG_CVV2: {type: 'wrongcvv'},
                COLLECTION_CARD_EXPIRED: {type: 'cardexp'},
                COLLECTION_INVALID_CARD_NUMBER: {type: 'invcardnum'},
                COLLECTION_DECLINED: {type: 'colldeclined'},
                FRAUD_NON_CHARGEABLE_ATTEMPT: {type: 'fraudnoncharg'},
                ITINERARY_PROVIDER_2: {type: 'itineraryprov'},
                COLLECTION_FRAUD_SUSPECT: {type: 'fraudsuspect'},
                COLLECTION_BUYERS_FUNDING_SOURCE_FAILED: {type: 'buyersFundingSourceFailed'},
                COLLECTION_UNSUPPORTED_GATEWAY_COLLECTION_METHOD: {type: 'forbgate'},
                COLLECTION_INSUFFICIENT_CREDIT: {type: 'insufficientCredit'},
                COLLECTION_WRONG_CREDITCARD_EXPIRATION_DATE: {type: 'wrongCcExpDate'},
                COLLECTION_WRONG_ELV_ACCOUNT: {type: 'wrongElvAccount'},
                COLLECTION_ORDER_NOT_AUTHORIZE: {type: 'orderNotAuth'},
                COLLECTION_CARD_NOT_IN_AUTHORIZERS_DB: {type: 'cardNotInAuthDb'},
                COLLECTION_ACQUIRER_UNAVAILABLE: {type: 'acquirerUnavailable'},
                COLLECTION_DATA_VALIDATION_ERROR: {type: 'dataValidationError'},
                COLLECTION_INVALID_AMOUNT: {type: 'invalidAmount'},
                COLLECTION_INVALID_CURRENCY: {type: 'invalidCurrency'},
                COLLECTION_AMOUNT_HIGHER_THAN_ALLOWED: {type: 'amountHigherThanAllowed'},
                BOOKING_PAYMENT_RETRY: {type: 'bookingPaymentRetry'},
                COLLECTION_UNKNOWN: {type: 'collectionUnknown'},
                COLLECTION_UNKNOWN_ORDER: {type: 'unknownOrder'},
                COLLECTION_UNKNOWN_ORIGIN_IP: {type: 'unknownOriginIp'},
                COLLECTION_ORDER_ALREADY_USED: {type: 'orderAlreadyUsed'},
                COLLECTION_TRANSACTION_NO_EXIST: {type: 'transactionNoExist'},
                BOOKING_STOP: {type: 'bookingStop'},
            };
            this.$widget.find('.od-payment-credit-card-mismatch').toggleClass('odf-hidden', true);
            this.$widget.find('.od-payment-validate-title').toggleClass('odf-hidden', false);
            if (hasFlowErrors) {
                message = Odigeo._.first(Odigeo._.values(params.flowErrors));
                Odigeo.trigger(this.widget.id + ':manageError', message.errorMessageKey);
                if (message.errorMessageKey) {
                    trackingUtils.trackEventWithCategory('flights_pay_page', 'payment_details_error', message.errorMessageKey);
                    switch (message.errorMessageKey) {
                        case 'FORBIDDEN_ATTEMPT_NEGATIVE_COLLECTION':
                            Odigeo._.templateSettings = {
                                evaluate: /\{\{#(.+?)\}\}/g,
                                interpolate: /\{\{([^#].*?)\}\}/g,
                            };

                            var content;
                            var errorNegativeFee = Odigeo._.template(this.$widget.find('.forbidden_attempt_negative_collection').html());
                            var nextDate = Odigeo.Utils.createDateFromString(message.messages.NEXT_AVAILABLE_DATE);
                            var templateValues = {
                                type: 'description',
                                next_available_date: Odigeo.Utils.formatDate(
                                    message.messages.NEXT_AVAILABLE_DATE,
                                    this.widget.options.velocityMessagesDateFormat
                                ),
                                credit_card_type_name: message.messages.CREDIT_CARD_TYPE_NAME,
                                days_to_date: Odigeo.Utils.getRemainingDays(nextDate.getTime()),
                                credit_card_number: message.messages.CREDIT_CARD_NUMBER,
                            };

                            content = errorNegativeFee(templateValues);
                            $('.paymentmanager_error_message[data-error-type="negative"]').html(content);
                            break;
                        case 'CART_TYPE_NOT_MATCH':
                            this.showPaymentRetryPopUp('dt', params.myTrip.paymentRetryInfo);
                            this.$cachedSelectors.paymentFailureMessage.addClass('hidden');
                            break;
                    }
                }
                error = errorsObj[message.errorMessageKey] || {};
                if (this.isNotCollectionRetryError(message.errorMessageKey)) {
                    this.widget.error = error.type ? error : {type: 'retry'};
                }
            } else {
                this.widget.error = {type: 'retry'};
            }
        },

        showPaymentRetryPopUp: function(flow, paymentRetryInfo) {
            var popup;
            var finalPrice;
            var messageDescription;
            var widget = this;
            var difference;
            var templateValues;
            var finalPriceValues;
            var buttons;
            var priceMsg;
            var creditCardMsg;
            var $ccCardTypeShowed = widget.$cachedSelectors.ccCardTypeShowed;

            Odigeo._.templateSettings = {
                evaluate: /\{\{#(.+?)\}\}/g,
                interpolate: /\{\{([^#].*?)\}\}/g,
            };

            creditCardMsg = Odigeo._.template(widget.$widget.find('.retry_card_not_match_template').html());
            if (flow === 'sm') {
                buttons = [
                    {
                        text: Odigeo.UIElements.translations.ubulayer.btn_check_ccinfo,
                        style: 'od-ui-dialog-button-cancel',
                        handler: function() {
                            $ccCardTypeShowed.val(paymentRetryInfo.newCreditCard.code).trigger(Odigeo.Events.change);
                            widget.$widget
                                .find('.od-payment-credit-card-message')
                                .text(creditCardMsg({type: 'msg', credit_card_found: paymentRetryInfo.newCreditCard.name}));
                            widget.$widget.find('.od-payment-credit-card-mismatch').toggleClass('hidden', false);
                            widget.$widget.find('.od-payment-validate-title').toggleClass('hidden', true);
                            Odigeo.UIElements.hideDialog(popup);
                        },
                    },
                    {
                        text: Odigeo.UIElements.translations.ubulayer.btn_book_now,
                        style: 'od-ui-dialog-button-default',
                        handler: Odigeo._.bind(function() {
                            $ccCardTypeShowed.val(paymentRetryInfo.newCreditCard.code).trigger(Odigeo.Events.change);
                            this.model.commit.apply(this.model, {showErrorsResume: true});
                            Odigeo.UIElements.hideDialog(popup);
                            //  Analytics: virtual page tracking
                            this._trackVirtualPage('payment', true);
                        }, this),
                    },
                ];
            } else {
                buttons = [
                    {
                        text: Odigeo.UIElements.translations.ubulayer.btn_book_now,
                        style: 'od-ui-dialog-button-default',
                        handler: Odigeo._.bind(function() {
                            $ccCardTypeShowed.val(paymentRetryInfo.newCreditCard.code).trigger(Odigeo.Events.change);
                            this.widget.execute('fillForm', paymentRetryInfo.paymentDetails.creditCardDetails);
                            Odigeo.UIElements.hideDialog(popup);
                            this.model.commit.apply(this.model, {showErrorsResume: true});
                            this._trackVirtualPage('payment', true);
                        }, this),
                    },
                    {
                        text: Odigeo.UIElements.translations.ubulayer.btn_check_ccinfo,
                        style: 'od-ui-dialog-button-cancel',
                        handler: function() {
                            $ccCardTypeShowed.val(paymentRetryInfo.newCreditCard.code).trigger(Odigeo.Events.change);
                            widget.$widget
                                .find('.od-payment-credit-card-message')
                                .text(creditCardMsg({type: 'msg', credit_card_found: paymentRetryInfo.newCreditCard.name}));
                            widget.$widget.find('.od-payment-credit-card-mismatch').toggleClass('hidden', false);
                            widget.$widget.find('.od-payment-validate-title').toggleClass('hidden', true);
                            widget.widget.execute('fillForm', paymentRetryInfo.paymentDetails.creditCardDetails);
                            Odigeo.trigger(widget.widget.id + ':resetAddingInsurance');
                            Odigeo.UIElements.hideDialog(popup);
                        },
                    },
                ];

                finalPriceValues = {
                    type: 'finalPrice',
                    total_price: Odigeo.Utils.formatCurrency(parseFloat(paymentRetryInfo.totalPrice)),
                };
            }
            messageDescription = Odigeo._.template(widget.$widget.find('.retry_card_not_match_template').html());

            finalPrice = Odigeo._.template(widget.$widget.find('.retry_card_not_match_template').html());

            difference = Odigeo._.template(widget.$widget.find('.retry_card_not_match_template').html());

            priceMsg = paymentRetryInfo.differencePrice >= 0 ? 'price_higher' : 'price_lower';

            templateValues = {
                type: 'description',
                credit_card_found: paymentRetryInfo.newCreditCard.name || '',
                credit_card_selected: paymentRetryInfo.oldCreditCard.name || '',
                price_difference: difference({
                    type: priceMsg,
                    price: Odigeo.Utils.formatCurrency(parseFloat(paymentRetryInfo.differencePrice)),
                }),
                total_price: Odigeo.Utils.formatCurrency(parseFloat(paymentRetryInfo.totalPrice)),
            };

            popup = Odigeo.UIElements.createDialog(
                '<b>' + Odigeo.UIElements.translations.ubulayer.title + '</b>',
                '<div class="od-ui-dialog-confirmation">' +
                    messageDescription(templateValues) +
                    '</div>' +
                    (!Odigeo._.isEmpty(finalPriceValues) ? finalPrice(finalPriceValues) : ''),
                buttons,
                'dialog-card-type-not-match',
                false,
                'info'
            );

            Odigeo.UIElements.showDialog(popup);

            $('.dialog-card-type-not-match')
                .find('.ubu_layer_more_details')
                .one('click', function() {
                    $('.dialog-card-type-not-match')
                        .find('.final-price')
                        .removeClass('hidden');
                    $(this).addClass('hidden');
                });
        },

        hideDialogs: function() {
            if (!Odigeo._.isUndefined(this.$cachedSelectors.ccCcvHint)) {
                this.$cachedSelectors.ccCcvHint.trigger('hideTooltip');
            }
        },

        fillForm: function(creditCardDetails) {
            var root = this.$cachedSelectors.root;
            var expirationMonth = parseInt(creditCardDetails.expirationMonth, 10);
            var expirationMonthFormatted = expirationMonth < 10 ? '0' + expirationMonth : expirationMonth;
            var $inputName = root.find('input[name=agree]');
            if (!this.widget.options.isMobileRevamp) {
                root.find('#payment-method-creditcard').prop('checked', true);
            }
            root.find('#payment-method-creditcard').trigger('change');
            root.find('input[data-name="nameoncard"]').val(creditCardDetails.owner);
            root.find('input[data-name="ccnumber"]')
                .val(creditCardDetails.number)
                .trigger(Odigeo.Events.input)
                .trigger(Odigeo.Events.keydown);
            root.find('input[data-name="creditCardExpiration"]').val('20' + creditCardDetails.expirationYear + '-' + expirationMonthFormatted);
            root.find('input[data-name="cvv2"]').val(creditCardDetails.securityNumber);

            if ($inputName) {
                $inputName.prop('checked', true);
            }
        },

        loadRepricingMessage: function(repricing) {
            this.widget.isRepricing = true;
            let priceDifference = repricing.data.newPrice - repricing.data.oldPrice;
            priceDifference = Number(priceDifference).toFixed(2);
            let text = '';
            const priceRatio = Math.abs(+(100 - (repricing.data.newPrice / repricing.data.oldPrice) * 100).toFixed(0));
            if (priceDifference > 0) {
                text = this.widget.options.repricingTextPositive;
            } else {
                text = this.widget.options.repricingTextNegative;
                text = text.replace('_price_ratio_', priceRatio);
            }
            text = text.replace('_price_', priceDifference);

            this.widget.error = {type: 'repricing', description: text};
        },

        getRepricingTrackingLabel: function(oldPrice, newPrice) {
            return 'iprice:' + oldPrice + '_fprice:' + newPrice + '_pax:' + passengersUtils.getNumberOfPassengers();
        },

        setManualPaymentRetry: function(data) {
            this.widget.isPaymentMethodRetry = data;
        },

        restoreFieldsLocalStorage: function() {
            if (this.widget.options.isStorePaymentStorageData) {
                this.storeData.restore('paymentData', getFields(this), 'paymentMethod', {});
            }
        },

        cleanInputs: function(clearAll) {
            let cardForms = this.$cachedSelectors.cardForms;
            if (this.widget.options.isMobileRevamp) {
                cardForms = cardForms.add(this.$cachedSelectors.storageCreditCardContainer);
                cardForms = cardForms.add(this.$cachedSelectors.storedCvvContainer);
            }
            Odigeo._.each(
                cardForms
                    .parent()
                    .find('.active')
                    .find('input[type="text"][name], input[type="tel"][name], select[name], select[data-name]'),
                Odigeo._.bind(function(el) {
                    var $el = $(el);
                    if (clearAll) {
                        $el.val([]);
                    }
                    if (Odigeo._.isEmpty($el.val()) || $el.val() === '-1') {
                        $el.closest('.validation_field').attr('data-state', '');
                    }
                }, this)
            );
        },

        setCreditCardTypeIcon: function(creditCardType) {
            this.$cachedSelectors.ccTypeIcon.attr('data-card', creditCardType);
        },

        blurAllInputs: function() {
            if (this.widget.options.bigCvv && this.widget.model.get('chosenMethod') === 'CREDITCARD') {
                this.cardFields.cvv2.execute('onBlur');
            }
        },

        cvvTypeChanged: function(isAmex) {
            this.$cachedSelectors.cvvHelpContainer.attr('data-cvv', isAmex ? 'cvv4' : 'cvv3');
            this.model.get('cardFields').cvv2.setValidLength(isAmex ? 4 : 3);
        },

        _trackEvent: function(action, label, category) {
            if (this.widget.id !== 'seatmap-payment-checkin') {
                trackingUtils.trackEventWithCategory(category || 'flights_pay_page', action, label);
            }
        },

        _trackVirtualPage: function(page, funnel) {
            trackingUtils.trackPage(page, {
                funnel: funnel,
            });
            tagManagement.updateDatalayer();
        },

        onTapOtherContainerInfoHint: function(event) {
            event.preventDefault();
            window.open(event.target.getAttribute('data-url'), '_blank', 'scrollbars=1,resizable=1,height=300,width=450');
        },

        onTapOtherContainerRadio: function(e) {
            this.changePaymentMethod(e.target.value);
        },

        onModelChangePaymentMethod: function(method) {
            this.$cachedSelectors.root.find('[data-method="' + method + '"]').addClass('active');
        },

        changePaymentMethod: function(method) {
            this.$cachedSelectors.root.find('[data-method="' + method + '"]').addClass('active');
            this.model.changePaymentMethod(method);
        },

        isNotCollectionRetryError: function(errorMessageKey) {
            return !Odigeo._.startsWith(errorMessageKey, 'COLLECTION_');
        },

        showConfirmationEmailMessage: function() {
            var userEmail = Odigeo.Utils.parseJson(Odigeo.Session.storage.bookingInfo).buyer.mail;
            this.$cachedSelectors.confirmationMessageContainer.removeClass('odf-hidden');
            this.$cachedSelectors.confirmationMessageEmail.append(userEmail);
        },

        onShowPsd2InfoMessage: function(europeanCard) {
            this.$cachedSelectors.psd2InfoMsg.toggleClass('opened', !!europeanCard);
            if (europeanCard) {
                trackingUtils.trackEvent('payment_details', 'psd2_message_shown');
            }
        },
    };
})();
